<script setup>
import { navigateTo, navigationItemsPersonal } from '../../../../utilities/account/useAccountNavigationPersonal'
import { formatCountry } from '../../../../utilities/helpers'
import AccountPanelIcon from '../../AccountPanelIcon.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'

const { naturalProfile: account } = usePersonalAccountDataState()
const emit = defineEmits(['edit'])

function edit() {
    emit('edit')
    navigateTo('Address Data')
}
</script>

<template>
    <div class="flex flex-wrap pb-6">
        <div class="flex w-full space-x-6 border-b border-t border-gray-200 bg-gray-50 px-4 py-2 sm:px-8">
            <AccountPanelIcon
                :navigation-items="navigationItemsPersonal"
                class="w-5"
                page="Address Data"></AccountPanelIcon>
            <span class="flex-1 text-sm font-bold text-gray-700">{{ $t('account_settings.address_data') }}</span>
            <button class="text-sm hover:text-gray-600" @click="edit">
                {{ $t('account_settings.edit') }}
            </button>
        </div>

        <div class="flex-1 pl-4 sm:pl-8">
            <div class="py-5">
                <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                            {{ $t('account.address') }}
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                            {{ account.address }}
                        </dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                            {{ $t('account.postal_code') }}
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                            {{ account.postal_code }}
                        </dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                            {{ $t('account.city') }}
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                            {{ account.city }}
                        </dd>
                    </div>
                    <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                            {{ $t('account.country') }}
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                            {{ formatCountry(account.country) }}
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
